import React, { Fragment, useMemo } from 'react';
import styled from 'styled-components';
import { Link } from '@material-ui/core';
import { Reference } from './Reference.interface';

const StyledLink = styled(Link)`
  cursor: pointer;
  text-decoration: underline;
`;

export interface ReferenceTypeLinksProps {
  refs: Reference | undefined;
  onClick?: (type: Reference) => void;
}

const ReferenceTypeLinks: React.FC<ReferenceTypeLinksProps> = (
  props: ReferenceTypeLinksProps
) => {
  const { refs, onClick } = props;
  const links: React.ReactNode = useMemo(() => {
    if (!refs) {
      return null;
    }
    return (
      <Fragment>
        <StyledLink onClick={() => onClick?.(refs)}>
          <code>{refs.typeName}</code>
        </StyledLink>
      </Fragment>
    );
  }, [refs, onClick]);

  return <>{links}</>;
};

export default ReferenceTypeLinks;
